import { parsePhoneNumberFromString } from 'libphonenumber-js/max';

export const parsePhoneNumber = (phoneNumber: string) => {
  return parsePhoneNumberFromString(phoneNumber);
};
